import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Badge } from "@tokenterminal/core/ui/messaging/badge/Badge"
import Link from "next/link"
import { GET_LISTED_URL } from "../contact/contact"
import { Logo } from "./Logo"
import { NewsletterSignup } from "./NewsletterSignup"
import { ThemeSwitcherToggle } from "./ThemeSwitcherToggle"

const footerLinks = {
  company: [
    { name: "About", href: "/about" },
    { name: "Careers", href: "/careers", tag: "We're hiring!" },
    { name: "Customers", href: "/customers" },
    { name: "Contact", href: "/contact" },
    { name: "Pricing", href: "/pricing" },
    { name: "Privacy policy", href: "/privacy-policy" },
    { name: "Terms", href: "/terms" },
  ],
  products: [
    { name: "Explorer", href: "/products/explorer" },
    { name: "Studio", href: "/products/studio" },
    { name: "MCP", href: "/products/mcp" },
    { name: "Sheets", href: "/products/sheets" },
    { name: "API", href: "/products/api" },
    { name: "Datashare", href: "/products/datashare" },
  ],
  partnerships: [
    { name: "Data Partnerships", href: "/products/data-partnerships" },
    { name: "Integrations", href: "/products/integrations" },
    { name: "Indexes", href: "/products/indexes" },
  ],
  explore: [
    {
      name: "API Docs",
      href: "https://tokenterminal.com/docs/api-reference/introduction",
    },
    // { name: "Blog", href: "https://tokenterminal.com/resources" },
    // { name: "Changelog", href: "https://tokenterminal.com/changelog" }, // Hidden until automated system is in place
    { name: "Docs", href: "https://tokenterminal.com/docs" },
    {
      name: "MVTT10F (index)",
      href: "https://www.marketvector.com/indexes/digital-assets/marketvector-token-terminal-fundamental",
    },
    {
      name: "MVTT10M (index)",
      href: "https://www.marketvector.com/indexes/digital-assets/marketvector-token-terminal-fundamental-cap-weighted-strategy",
    },
    { name: "Resources", href: "/resources" },
  ],
  socials: [
    { name: "X", href: "https://x.com/tokenterminal" },
    { name: "Discord", href: "https://discord.com/invite/tokenterminal" },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/token-terminal",
    },
    { name: "YouTube", href: "https://www.youtube.com/tokenterminal" },
    { name: "Podcast", href: "/resources/interview" },
  ],
}

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div className="bg-white dark:bg-bg-surface text-fg-default py-5 px-5">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between gap-4 mb-5 py-3">
          <Link href="/" className="block">
            <Logo />
          </Link>
          <LinkButton href={GET_LISTED_URL}>Get listed</LinkButton>
        </div>
        <div className={`flex flex-col md:flex-row gap-6 items-start`}>
          {Object.entries(footerLinks).map(([section, links]) => (
            <div
              key={section}
              className="flex flex-col w-[250px] shrink mb-6 md:mb-0"
            >
              <div className="text-[14px] font-medium mb-4">
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </div>
              <div className="flex flex-col gap-1.5 items-start max-w-full">
                {links.map((link) => (
                  <Link
                    key={link.name}
                    href={link.href}
                    className="text-[14px] font-medium text-fg-secondary mb-[5px] no-underline hover:text-fg-default transition"
                  >
                    {link.name}
                    {"tag" in link && (
                      <Badge
                        size="small"
                        color="cyan"
                        style={{ marginLeft: "4px" }}
                      >
                        {link.tag}
                      </Badge>
                    )}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <NewsletterSignup />
        <div className="flex items-center justify-between gap-2 mt-9 mb-7">
          <div className="text-left text-[#565656] text-[14px]">
            © {currentYear} Token Terminal
          </div>
          <ThemeSwitcherToggle />
        </div>
      </div>
    </div>
  )
}

export default Footer
